
export const environment = {
  production: true,
  //version: '0.1.0',  //{date} = date of release,{build} = dev:0 prod:1 ,{feature} = feature number,{fix} = fix number

  //API endpoints that can be used from siteName
  apiUrl: [
    { "name": "OPACCURR", "url": "https://clmopac.walaiautolib.com/curriculumapi", "token": "", "description": "test Curriculum" },
    { "name": "OPACPV", "url": "https://clmpvapi.walaiautolib.com/opacapi", "token": "", "description": "test Privilege" },
    { "name": "WU", "url": "https://opac-api.wu.ac.th/v1", "token": "Gz94UexzVMknK+GruhEn1hDBikW5AAjAnSoeEUDi2sXhDe2Tu4cO5MVuqnq81UC9IAj87+hXgsQveZ/IbLsmMiIIy8svTzlXgCIf/K5NJMc=", "description": "CLM" },
    { "name": "URU", "url": "https://libapi.uru.ac.th/v2", "token": "hy5xJl3czSEYf/HahEa1Lncdu4GkbnKGs80azVTDsMKncSGXBgtLN0o2PSHG9DhySpeCsdJ/VzxL96RFnsKAvsoYasCWfOz/+YfpdyEZGc4=", "description": "อุตรดิต" },
    { "name": "MSU", "url": "https://libapp.msu.ac.th/opacapi", "token": "s8HPWYD8X848ZOJNFiHLZ+1BBgwhCxxXv58Ym4+BGsrUYapOVfOi7M1Dxw0FvWziAI7x47JToi28Kt3sw/wf8WbZaKDinTenKpdEibPGCgw=", "description": "มมส" },
    { "name": "SRU", "url": "https://libapi.sru.ac.th/v1", "token": "", "description": "สุราษ" },
    { "name": "KVIS", "url": "https://libapi.vistec.ac.th/kvis", "token": "", "description": "KVIS" },
    { "name": "VISTEC", "url": "https://libapi.vistec.ac.th/vistec", "token": "", "description": "VISTEC" },
    { "name": "CMRU", "url": "https://libapp.cmru.ac.th/v1", "token": "", "description": "CMRU" },
    { "name": "RMUTSV", "url": "https://apiopac.rmutsv.ac.th/opac", "token": "", "description": "RMUTSV" },
    { "name": "RMUTT", "url": "https://libapi.rmutt.ac.th/v1", "token": "iyb8Fz/KghS8JbS8xKqEHjQxJ5ddFJYFV3lZVGGquewvpMMywFcJpbYzYQ9EZNpV/Al128WfaOUmvI3kJT9n53ZrDARwENbBG5h2dUfowZw=", "description": "RMUTT" },
    { "name": "RMUTP", "url": "https://libapi.rmutp.ac.th/v1", "token": "", "description": "RMUTP" },
    { "name": "BUU", "url": "https://opac1.lib.buu.ac.th/opacapi", "token": "7F82rs6Xw20ueRERlsUJyv5izM7meP5eXwIP9JL9UYDLreowx8pUWorz+mAPpkeGOGNjO33L8NSF1Q7p0uPIvs76VwKTCtIwMwUoqEoB4hU=", "description": "BUU" },
    { "name": "NPU", "url": "https://opacapi.npu.ac.th/v1", "token": "", "description": "NPU" },
    { "name": "TSU", "url": "https://libapi.tsu.ac.th/v1", "token": "", "description": "TSU" },
    { "name": "UBU", "url": "https://medias.lib.ubu.ac.th/opacapi", "token": "", "description": "UBU" },
    { "name": "TSS", "url": "https://opacapi.tss-tu.com/tsstu", "token": "", "description": "สาธิตธรรมศาสตร์" },
    { "name": "MOJ", "url": "https://libapi.moj.go.th/opacapi", "token": "bC8FnW58HsLzHaeMLnMM6ZLw2dB3L41k0znPbXohS0Kypg7UL6e7vChm6nPhTtH6DGk38TrKirQz9xAsTl1EqryTPxycpMIwLnswvaVg5Ls=", "description": "MOJ" },
    { "name": "PHAS", "url": "https://opacapi-phas.pi.ac.th/phas", "token": "", "description": "วสส" },
    { "name": "NSTRU", "url": "https://libapi.nstru.ac.th/nstru", "token": "", "description": "ราชภัฎนคร" },
    { "name": "APPU", "url": "https://api.appu-digitallibrary.org/appu", "token": "", "description": "APPU http://192.168.1.3/appu" },
    { "name": "RMUTL", "url": "https://opacapp.rmutl.ac.th/opacapi", "token": "", "description": "RMUTL" },
    { "name": "RMUTSB", "url": "https://lib3api.rmutsb.ac.th/rmutsb", "token": "", "description": "RMUTSB" },
    { "name": "SU", "url": "https://app.lib.su.ac.th/opacapi", "token": "", "description": "SU" },
    { "name": "PSRU", "url": "https://catalog-lib.psru.ac.th/opacapi", "token": "", "description": "PSRU" },
    { "name": "TCDC", "url": "http://172.16.70.104/opacapi", "token": "", "description": "TCDC" },
    { "name": "PNU", "url": "http://172.16.0.145/opacapi", "token": "", "description": "PNU" },
    { "name": "KKU", "url": "https://opac-mirror.kku.ac.th/opacapi", "token": "", "description": "KKU" },
    { "name": "MWIT", "url": "https://lib-api.mwit.ac.th/opacapi", "token": "7UpZ1RGz0Ges6oIKBN2YnmIY66iAmpTbCjDxDD290gw4pBmfo/dl5onWDoeRZnPUCxMilQcfENuScv8rEbqWscrCqo9LcxLnKubygEoB+Qg=", "description": "MWIT" },
    { "name": "PCRU", "url": "https://opacapp.pcru.ac.th/opacapi", "token": "", "description": "PCRU" },
    { "name": "CPRU", "url": "https://api.cpru.ac.th/opac", "token": "", "description": "CPRU" },
    { "name": "WULIB", "url": "https://clmopac.walaiautolib.com/api", "token": "ebggDJ57As99uLotg9l7aGlNENzAGzyZjGg+fne9p2m8sy3MxZ5fFcGjvN7S1ObHQls8OWyjpChHp4O5MkQ4pwKSeKa/yCsK5H38k87vVRg=", "description": "WULIB" },
    { "name": "KMITL", "url": "https://apikmitl.walaiautolib.com/opacapi", "token": "BYUCQQS362N6NiuTZAQ+4B9W79np9IzIA2zSQcRcKyy25UJhqxyyqY/CyuAlgbk+CZ2cWsGc1eaTxBBvzq7LHFadqUvco8ZjYMYrQUSQDHQ=", "description": "KMITL" },
    { "name": "RMUTR", "url": "https://libapi.rmutr.ac.th/opacapi", "token": "AY/mHuOZQKQEYNBxgUAFHMk09olqRZUSK5JP8YBUOP3ENp+SGMFJQkuxqh0V7YF+FK/A4vPMxeEKEs0/IYl0JNyeCgn1FZ+AM3b1eWbakKQ=", "description": "RMUTR" },
    { "name": "NSM", "url": "https://libapp.nsm.or.th/opacapi", "token": "tUTwPPRxCIchE23JiYPoRn3FVjkMJGk4NHljs2RAp5E89XMW7KwZ8bZ8tqp+dkTYmD4Oi1uq2m1Rduinmmh7dbmSBEZjPTQRB1Lnqr7IJb0=", "description": "NSM" }

  ],

  //SSO Authentication API
  apiSSOAuth: [
    { "name": "UBU", "url": "https://medias.lib.ubu.ac.th/ubulogin/api/login", "token": "", "description": "UBU" },
    { "name": "KKU-login-logout", "url": "https://ssonext.kku.ac.th", "token": "01980bdb-3561-7479-b106-63f325ccf80d", "description": "KKU login,logut token = appID  /logout?app=<AppID> /login?app=<AppID>" },
    { "name": "KKU-ssoapi", "url": "https://opac-mirror.kku.ac.th/ssoapi/api/sso", "token": "", "description": "KKU SSO" },
    { "name": "KMITL-login", "url": "https://kmitlssodev.walaiautolib.com?urlBack=", "token": "", "description": "KMITL SSO login" },
    { "name": "KMITL-logout", "url": "https://my.openathens.net/signout", "token": "", "description": "KMITL SSO logout" }
  ],

  //Privilege API
  apiPV: [
    { "name": "OPACCURR", "url": "https://clmopac.walaiautolib.com/pvapi", "token": "", "openPV": false },
    { "name": "OPACPV", "url": "https://clmpvapi.walaiautolib.com/pvapi", "token": "", "openPV": true },
    { "name": "WU", "url": "https://opac-api.wu.ac.th/pvapi", "token": "", "openPV": true },

  ],

  //Curriculum API
  apiCurriculum: [
    { "name": "OPACCURR", "url": "https://clmopac.walaiautolib.com/curriculumapi", "token": "", "openCurriculum": true },
    { "name": "OPACPV", "url": "https://clmpvapi.walaiautolib.com/curriculumapi", "token": "", "openCurriculum": false },
    { "name": "WU", "url": "https://opac-api.wu.ac.th/v1", "token": "", "openCurriculum": true },
    { "name": "SU", "url": "https://app.lib.su.ac.th/opacapi", "token": "", "openCurriculum": true },

  ],

  //Default location settings
  defaultLocation: [
    { "name": "OPACCURR", "defaultLocationID": "1", "defaultLocationName": "OPAC Dev" },
    { "name": "WU", "defaultLocationID": "1", "defaultLocationName": "ศูนย์บรรณสารและสื่อการศึกษา" }
  ],

  //Self check settings
  openSelfCheck: [
    { "name": "BUU", "openSelfCheck": true, "description": "BUU Self Check" }
  ],

  //1=Use other, 0= Use in my library only
  useWalaiBookCover: [
    { "name": "OPACCURR", "useWalaiBookCover": "0", "description": "OPAC test" },
    { "name": "OPACPV", "useWalaiBookCover": "0", "description": "OPAC test" },
    { "name": "WU", "useWalaiBookCover": "0", "description": "ศูนย์บรรณสารและสื่อการศึกษา" },
    { "name": "URU", "useWalaiBookCover": "0", "description": "อุตรดิต" },
    { "name": "MSU", "useWalaiBookCover": "0", "description": "มมส" },
    { "name": "SRU", "useWalaiBookCover": "0", "description": "สุราษ" },
    { "name": "KVIS", "useWalaiBookCover": "0", "description": "KVIS" },
    { "name": "VISTEC", "useWalaiBookCover": "0", "description": "VISTEC" },
    { "name": "CMRU", "useWalaiBookCover": "0", "description": "CMRU" },
    { "name": "RMUTSV", "useWalaiBookCover": "0", "description": "RMUTSV" },
    { "name": "RMUTT", "useWalaiBookCover": "0", "description": "RMUTT" },
    { "name": "RMUTP", "useWalaiBookCover": "0", "description": "RMUTP" },
    { "name": "BUU", "useWalaiBookCover": "0", "description": "BUU" },
    { "name": "NPU", "useWalaiBookCover": "0", "description": "NPU" },
    { "name": "TSU", "useWalaiBookCover": "0", "description": "TSU" },
    { "name": "UBU", "useWalaiBookCover": "0", "description": "UBU" },
    { "name": "TSS", "useWalaiBookCover": "1", "description": "สาธิตธรรมศาสตร์" },
    { "name": "MOJ", "useWalaiBookCover": "1", "description": "MOJ" },
    { "name": "PHAS", "useWalaiBookCover": "1", "description": "วสส" },
    { "name": "NSTRU", "useWalaiBookCover": "1", "description": "ราชภัฎนคร" },
    { "name": "APPU", "useWalaiBookCover": "0", "description": "APPU" },
    { "name": "RMUTL", "useWalaiBookCover": "1", "description": "RMUTL" },
    { "name": "RMUTSB", "useWalaiBookCover": "1", "description": "RMUTSB" },
    { "name": "SU", "useWalaiBookCover": "0", "description": "SU" },
    { "name": "PSRU", "useWalaiBookCover": "0", "description": "PSRU" },
    { "name": "TCDC", "useWalaiBookCover": "0", "description": "TCDC" },
    { "name": "PNU", "useWalaiBookCover": "0", "description": "PNU" },
    { "name": "KKU", "useWalaiBookCover": "1", "description": "KKU" },
    { "name": "MWIT", "useWalaiBookCover": "0", "description": "MWIT" },
    { "name": "PCRU", "useWalaiBookCover": "0", "description": "PCRU" },
    { "name": "KMITL", "useWalaiBookCover": "1", "description": "KMITL" },
    { "name": "RMUTR", "useWalaiBookCover": "0", "description": "RMUTR" },
    { "name": "NSM", "useWalaiBookCover": "0", "description": "NSM" }
  ],


  //Book result display settings in search page
  displayBookResult: [
    { "name": "OPACCURR", "value": "Table", "description": "test Curriculum" },
    { "name": "OPACPV", "value": "Table", "description": "test Privilage" },
    { "name": "WU", "value": "Table", "description": "CLM" },
    { "name": "URU", "value": "List", "description": "อุตรดิต" },
    { "name": "MSU", "value": "List", "description": "มมส" },
    { "name": "SRU", "value": "List", "description": "สุราษ" },
    { "name": "KVIS", "value": "List", "description": "KVIS" },
    { "name": "VISTEC", "value": "List", "description": "VISTEC" },
    { "name": "CMRU", "value": "List", "description": "CMRU" },
    { "name": "RMUTSV", "value": "List", "description": "RMUTSV" },
    { "name": "RMUTT", "value": "List", "description": "RMUTT" },
    { "name": "RMUTP", "value": "List", "description": "RMUTP" },
    { "name": "BUU", "value": "List", "description": "BUU" },
    { "name": "NPU", "value": "List", "description": "NPU" },
    { "name": "TSU", "value": "List", "description": "TSU" },
    { "name": "UBU", "value": "List", "description": "UBU" },
    { "name": "TSS", "value": "List", "description": "สาธิตธรรมศาสตร์" },
    { "name": "MOJ", "value": "List", "description": "MOJ" },
    { "name": "PHAS", "value": "List", "description": "วสส" },
    { "name": "NSTRU", "value": "List", "description": "ราชภัฎนคร" },
    { "name": "APPU", "value": "List", "description": "APPU" },
    { "name": "RMUTL", "value": "List", "description": "RMUTL" },
    { "name": "RMUTSB", "value": "List", "description": "RMUTSB" },
    { "name": "SU", "value": "List", "description": "SU" },
    { "name": "PSRU", "value": "List", "description": "PSRU" },
    { "name": "TCDC", "value": "List", "description": "TCDC" },
    { "name": "PNU", "value": "List", "description": "PNU" },
    { "name": "KKU", "value": "List", "description": "KKU" },
    { "name": "MWIT", "value": "List", "description": "MWIT" },
    { "name": "PCRU", "value": "List", "description": "PCRU" },
    { "name": "KMITL", "value": "List", "description": "KMITL" },
    { "name": "RMUTR", "value": "List", "description": "RMUTR" },
    { "name": "NSM", "value": "List", "description": "NSM" }
  ],


  //Google Analytics settings
  MeasurementID: [
    { "name": "PHAS", "id": "G-S110PC5W31", "description": "วสส" },
    { "name": "RMUTSB", "id": "G-04YZ36BC8H", "description": "RMUTSB" },
    { "name": "UBU", "id": "G-8GCEDH4D18", "description": "UBU" },
    { "name": "MOJ", "id": "G-CL81LJYHS9", "description": "MOJ" },
    { "name": "TSS", "id": "G-7P1V29VG18", "description": "TSS" },
    { "name": "KKU", "id": "UA-83060958-11", "description": "kku" },
    { "name": "NSTRU", "id": "UA-77242599-1", "description": "nstru" },
    { "name": "SET", "id": "UA-74443868-3", "description": "มารวย SET" },
    { "name": "RMUTP", "id": "G-H60YJLFKP9", "description": "มทร.พระนคร 151500590-3" },
    { "name": "TSU", "id": "UA-83060958-3", "description": "ม.ทักษิน" },
    { "name": "PEA", "id": "UA-83060958-4", "description": "pea" },
    { "name": "RMUTL", "id": "UA-83060958-5", "description": "rmutl" },
    { "name": "WU", "id": "G-TKNXR32N9M", "description": "CLM UA-83060958-6 (GA4: G-TKNXR32N9M)" },
    { "name": "SAC", "id": "UA-83060958-8", "description": "SAC" },
    { "name": "CC", "id": "UA-83060958-12", "description": "cc" },
    { "name": "CDTC", "id": "UA-83060958-14", "description": "cdtc จิตรลดา" },
    { "name": "RMUTSV", "id": "UA-83060958-17", "description": "rmutsv" },
    { "name": "YRU", "id": "UA-83060958-16", "description": "yru" },
    { "name": "PCRU", "id": "UA-83060958-19", "description": "pcru" },
    { "name": "KMITL", "id": "G-NDHWY3KQQK", "description": "kmitl (สจล) UA-151500590-5" },
    { "name": "RMUTR", "id": "UA-83060958-20", "description": "RMUTR" },
    { "name": "RMUTT", "id": "UA-151500590-6", "description": "RMUTT" },
    { "name": "PSRU", "id": "UA-151500590-4", "description": "PSRU" },
    { "name": "CMRU", "id": "UA-151500590-7", "description": "CMRU" },
    { "name": "OPACDEV", "id": "G-69CBD5C3Y0", "description": "opac2023 test" },
    { "name": "MSU", "id": "G-XK8H2R1EBR", "description": "มมส" }
  ],

  //Cookie Consent setting script
  // cookieConsent: false,
  cookieConsent: [
    { "name": "BUU", "data": "KqXrz9aMYarAmHeDP4G99hVt", "used": true, "pdpa": "https://www.lib.buu.ac.th/web/index.php/th/pdpa/", "description": "" },
    { "name": "NPU", "data": "bQaRBTpp49Y5rd29JGwJUVTN", "used": false, "pdpa": "", "description": "" },
    { "name": "TSU", "data": "UNoWUwJ7JBZo11U8QMk4Sh8C", "used": true, "pdpa": "", "description": "" },
    { "name": "MOJ", "data": "CSXsJPSYWFaEGdPvgMv7CkZx", "used": true, "pdpa": "", "description": "" },
    { "name": "OPAC", "data": "4kL5bJ4mJ7N2e1bPGYebdhrD", "used": false, "pdpa": "", "description": "" },
    { "name": "KKU", "data": "", "used": true, "pdpa": "", "description": "ใช้ script ของ KKU ไม่ได้ใช้ cookie consent" },
  ]
};